/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/dropdown.config.json';
import { StorageModule } from '@vlinder-web/storage-module-react';

export interface IDropdownMethods extends IPluginMethodMap {
  getDropdownItems(args: any): Promise<any>;
}

export class DropdownService implements IAgentPlugin {
  readonly methods: IDropdownMethods;

  constructor() {
    this.methods = {
      getDropdownItems: this.getDropdownItems.bind(this),
    };
  }

  async getDropdownItems(args: any) {
    const storageSrv = StorageModule.getInstance();

    let _sessionToken = storageSrv.get('userProfile', 'session');
    let _localToken = storageSrv.get('userProfile', 'local');
    let _userToken = _sessionToken ?? _localToken;
    let dropDownData = { ...(config || {}) }.dropdownItems.filter(
      (item) => item?.id !== 'switchRole' || _userToken?.userRoles?.length > 1
    );
    let _configData = {
      ...(config || {}),
      // dropdownItems: dropDownData,
    };
    console.log('dyp->', config, dropDownData);
    return {
      ...(_configData || {}),
    };
  }
}
